export enum ContactCategory {
    Customer = 'customer',
    Employee = 'employee',
    InterestedParty = 'interestedParty',
    Supplier = 'supplier'
}
